import React from 'react';
import { ActionButtonLayout } from '../../../../../../v2BaseComponents/ActionButtonLayout';
import { getIntl } from '../../../../../../../utils/intl';
import Text from '../../../../../../v2BaseComponents/Text';
import Stack from '../../../../../../v2BaseComponents/Stack';
import MainContentContainer from '../../../../../../v2BaseComponents/MainContentContainer';
import LabelValueDisplay from '../../../../../../v2BaseComponents/LabelValueDisplay';
import { useAutoLogout } from '../../../../../../SessionProvider';

const intl = getIntl('SecuritySettingsDetailsContent', {
    edit: 'Edit',
    logoAlt: 'Organization logo',
    sessionTimeoutMin: 'Session Timeout (Minutes)',
    sessionTimeoutExplanation: 'Users will see a prompt to stay signed in at {minutes} into the session',
    noTimeoutSet: 'No Timeout Set',
});

export type OrganizationDetailsContentOwnProps = {
    orgSessionTimeout: number | null | undefined;
    isOrgAdmin: boolean;
    onEdit: () => void;
};

export type OrganizationDetailsContentProps = OrganizationDetailsContentOwnProps;

const SecuritySettingsDetailsContent: React.FC<OrganizationDetailsContentProps> = (props) => {
    const sessionTimeoutMinutes = props.orgSessionTimeout;
    const { inactivityTimerValue, isInWarningPeriod } = useAutoLogout();

    return (
        <ActionButtonLayout
            scrollable
            actions={[
                {
                    title: intl('edit'),
                    onPress: props.onEdit,
                    show: props.isOrgAdmin,
                    icon: 'Edit',
                    testID: 'edit-session-timeout-button',
                },
            ]}
            whiteBackground
        >
            <MainContentContainer>
                <Stack vertical fullWidth align="flex-start" space={10} testID="security-settings-details-content">
                    <Text variant="bold-h4">Access Controls</Text>
                    <LabelValueDisplay
                        items={[
                            {
                                label: intl('sessionTimeoutMin'),
                                value: sessionTimeoutMinutes || intl('noTimeoutSet'),
                                testID: 'session-timeout-display',
                            },
                        ]}
                    />

                    <Text variant="subtitle-2">
                        {!sessionTimeoutMinutes
                            ? 'Auto-logout disabled for this organization'
                            : isInWarningPeriod
                            ? 'Warning period active'
                            : intl('sessionTimeoutExplanation', {
                                  minutes:
                                      inactivityTimerValue >= 60
                                          ? Math.floor(inactivityTimerValue / 60) + ' minutes'
                                          : (inactivityTimerValue % 60).toString().padStart(2, '0') + ' seconds',
                              })}
                    </Text>
                </Stack>
            </MainContentContainer>
        </ActionButtonLayout>
    );
};

export default React.memo(SecuritySettingsDetailsContent);
